/**
 * Reusable validation functions for survey questions
 */

export const validations = {
  // Simple required validation for radio/select
  required: (value) => value ? null : 'Por favor, selecione uma opção',

  // Age validation
  age: (value) => {
    if (!value) return 'Por favor, informe sua idade';
    const age = parseInt(value);
    if (age < 18) return 'Você precisa ter pelo menos 18 anos';
    if (age > 100) return 'Por favor, informe uma idade válida';
    return null;
  },

  // Checkbox with min/max selections
  checkboxMinMax: (min, max) => (value) => {
    if (!value?.selections?.length) {
      return 'Por favor, selecione pelo menos uma opção';
    }
    if (value.selections.length < min) {
      return `Por favor, selecione pelo menos ${min} ${min === 1 ? 'opção' : 'opções'}`;
    }
    if (value.selections.length > max) {
      return `Por favor, selecione no máximo ${max} ${max === 1 ? 'opção' : 'opções'}`;
    }
    if (value.selections.includes('outro') && !value.otherText?.trim()) {
      return 'Por favor, especifique o outro interesse';
    }
    return null;
  },

  // Rating validation - ensures all statements are rated
  ratingComplete: (statementIds) => (value) => {
    if (!value || typeof value !== 'object') {
      return 'Por favor, avalie todas as afirmações';
    }

    for (const statementId of statementIds) {
      if (!value[statementId]) {
        return 'Por favor, avalie todas as afirmações';
      }
    }

    return null;
  },

  // Sortable validation - ensures selections and ordering
  sortableMinMax: (min, max) => (value) => {
    if (!value?.selections?.length || !value?.order?.length) {
      return `Por favor, selecione pelo menos ${min} ${min === 1 ? 'opção' : 'opções'}`;
    }

    if (value.selections.length < min) {
      return `Por favor, selecione pelo menos ${min} ${min === 1 ? 'opção' : 'opções'}`;
    }

    if (value.selections.length > max) {
      return `Por favor, selecione no máximo ${max} ${max === 1 ? 'opção' : 'opções'}`;
    }

    // Ensure order matches selections
    if (value.order.length !== value.selections.length) {
      return 'Por favor, ordene todas as opções selecionadas';
    }

    return null;
  }
};
